#import "../../../core-entity/graphql/fragments/widget-fragment-full.graphql"
#import "../../../core-entity/graphql/fragments/header-field-fragment.graphql"

query GetPeepWidgets($entityType: WidgetEntityType!) {
    entityTypeWidgets(entityType: $entityType) {
        workspaceWidgets {
            ...WidgetFragmentFull
        }
        sidebarWidgets {
            ...WidgetFragmentFull
        }
        headerFields {
            ...HeaderFieldFragment
        }
    }
}
